const config = [
  {
    domain: [
      'resources1.interface003.com',
      'checkrobort.wikifx.com',
      'head-sg.zy223.com',
      'resources.fxeye2021.com',
      'resources.fxrdc.com',
      'resources.interface001.com',
      'resources.interface002.com',
      'resources.interface003.com',
      'resources.interface004.com',
      'resources.interface005.com',
      'resources1.interface003.com',
    ],
    webpSuffix: '_list',
  },
  {
    domain: [
      'eimgreview.souhei.com.cn',
      'eimgreview.fx960.com',
      'eimgjys.fxeyee.com',
      'img.souhei.com.cn',
      'img.zy223.com',
    ],
    webpSuffix: '-webp',
  },
  { domain: ['rating.zy223.com', 'h8imgs.zy223.com', 'h8imgs.ruiyin999.cn'], webpSuffix: '_webp' },
]

export function getOssDomainAndWebpSuffix(url) {
  for (let i = 0; i < config.length; i++) {
    const item = config[i]
    for (let j = 0; j < item.domain.length; j++) {
      const domain = item.domain[j]
      if (url.includes(domain)) {
        return item.webpSuffix
      }
    }
  }
  return ''
}
